"use strict";

var d3 = require('d3');

var toolTipHandler = {};

toolTipHandler.addMinimalContent = function (htmlContent, toolTip) {

  toolTip.minimal.htmlContent.html(htmlContent);
  displayTooltip(true, toolTip);
};

toolTipHandler.addExtendedContent = function (htmlContent, toolTip) {

  toolTip.minimal.htmlContent.html(htmlContent);
  displayTooltip(true, toolTip);
};

toolTipHandler.position = function (toolTip, event) {

  // the 'pointer' shows a triangle under the tooltip. Avoid it for now
  // toolTip.minimal.pointer.attr('class', pos.className); // origin code
  toolTip.minimal.pointer.style("display", "none");

  var tooltipElement = d3.select('.tooltip');
  var minimalRect = tooltipElement.select('.minimal').node().getBoundingClientRect();
  var minimalCenterW = minimalRect.width / 2;

  // display by default the tooltip message centered and above the mouse pointer
  var left = event.offsetX - minimalCenterW;
  var top = event.offsetY - minimalRect.height - 10;

  // get the client's area of the container form
  var offsetParent = window.document.getElementById("similarPatientsAnalyticsFormInternalID");
  var offsetParentRect = offsetParent.getBoundingClientRect();

  // get if the display of the tooltip exceeds the width of the form.
  // if tooltip message is hidden or partially hidden on left of the form, move the message to the left
  //  of the mouse pointer
  var widthExceed = left + minimalRect.width - offsetParentRect.width;
  if (widthExceed > 0) {
    left -= widthExceed + 10;
  }

  // get if the display of the tooltip exceeds the top of the form.
  // Meaning, if the display of the tooltip message is hidden or partially hidden on top of the form,
  //  display the tooltip on the left and on parallel to the current mouse position
  var factor = offsetParentRect.top < 0 ? -1 : 1;
  var tp = offsetParentRect.top * factor;

  var topSmallerTMsgH = top < minimalRect.height + 10;
  var topAndMsgGreaterTFormTop = top + minimalRect.height > offsetParentRect.top;
  var topMinusFormTopSmallerTMsgH = top - tp + 10 < minimalRect.height;
  //let pageYMinusFormTopSmallerTMsgH = (event.pageY-tp+10)<minimalRect.height;

  if (topMinusFormTopSmallerTMsgH && topSmallerTMsgH && topAndMsgGreaterTFormTop) {
    top = event.offsetY + 15;
    left = Math.min(left, event.offsetX - minimalRect.width - 15);
  }

  toolTip.style("top", +top + "px").style("left", +left + "px");
};

toolTipHandler.remove = function (toolTip) {

  displayTooltip(false, toolTip);
};

function displayTooltip(active, toolTip) {

  toolTip.active = active;
  if (active) {
    toolTip.style('display', 'inline-block');
  } else {
    toolTip.style('display', 'none');
  }
}

module.exports = toolTipHandler;